__turbopack_context__.v({
  "button": "TryGoldButton-module-scss-module__BbgODq__button",
});
